// extracted by mini-css-extract-plugin
export var container = "ProjectsLayout-module--container--e58a7";
export var fadeInAnimation = "ProjectsLayout-module--fadeInAnimation--53dda";
export var title = "ProjectsLayout-module--title--f51f6";
export var topRow = "ProjectsLayout-module--topRow--78f9d";
export var wrapper = "ProjectsLayout-module--wrapper--cd943";